import './App.css';
import Navbar from './components/Navbar';
import { UserAuth } from './context/UserAuth';
import { Routes, Route } from "react-router-dom"
import Home from "./components/Home";
import Login from "./components/Login";
import Aboutus from "./components/Aboutus";

function App()
{
  return (
    <>
      <UserAuth>
        <Navbar />

        <Routes>
          <Route path={"/login"} element={<Login />} />
          <Route path={"/"} element={<Home />} />
          <Route path={"/about"} element={<Aboutus />} />
        </Routes>
      </UserAuth>

    </>
  );
}

export default App;
